import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IRevolvingDataFormMeta {
    creditProgram: FormInputMeta;
    defaultPaymentMode: FormInputMeta;
    warrantyType: FormInputMeta;
    warrantyValue: FormInputMeta;
    creditLimit: FormInputMeta;
    balance: FormInputMeta;
    effectiveCreditLimitDate: FormInputMeta;
    accumulationTransaction: FormInputMeta;
    accumulationAuthorization: FormInputMeta;
    available: FormInputMeta;

    schema: any;
}

const revolvingDataFormMeta = {} as IRevolvingDataFormMeta;

revolvingDataFormMeta.creditProgram = {
    name: "creditProgram",
    type: "select",
    label: "Programme Crédit",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.defaultPaymentMode = {
    name: "defaultPaymentMode",
    type: "select",
    label: "Mode Paiement par Défault",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.warrantyType = {
    name: "warrantyType",
    type: "select",
    label: "Type Garantie",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.warrantyValue = {
    name: "warrantyValue",
    type: "text",
    label: "Valeur Garantie",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.creditLimit = {
    name: "creditLimit",
    type: "text",
    label: "Limite Crédit",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.balance = {
    name: "balance",
    type: "text",
    label: "Solde",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.effectiveCreditLimitDate = {
    name: "effectiveCreditLimitDate",
    type: "date",
    label: "Date Effective Limite Crédit",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.accumulationTransaction = {
    name: "accumulationTransaction",
    type: "text",
    label: "Cumul Transaction",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.accumulationAuthorization = {
    name: "accumulationAuthorization",
    type: "text",
    label: "Cumul Autorisation",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.available = {
    name: "available",
    type: "text",
    label: "Disponible",
    placeholder: "",
    validation: yup.string()
};

revolvingDataFormMeta.schema = yup.object().shape(getValidationSchema(revolvingDataFormMeta));

export default revolvingDataFormMeta;